export default __webpack_public_path__ + "static/media/volatile-solid-icon.989581d2.svg";